import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IpoApiService } from '@ip-only/front-end-library';
import { environment } from '../../../environments/environment';
import { FolderLink } from '../user';

const portalUsersApiUrl = `${environment.portalApiUrl}/folder-link`;

@Injectable({ providedIn: 'root' })
export class FolderlinkApiService implements IpoApiService<FolderLink> {
  constructor(private http: HttpClient) {}

  fetchSingle(projectId: string) {
    return this.http.get<FolderLink>(
      `${portalUsersApiUrl}?projectId=${projectId}`,
    );
  }
}
